module.exports = __webpack_public_path__ + "static/media/0.ed99237c.jpg";